import {
  Component,
  HostBinding,
  input,
  output,
  booleanAttribute,
  computed
} from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'umss-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './card.component.html',
  styleUrls: ['./card.component.scss']
})
export class UmssCardComponent {
  @HostBinding('style.display') display = 'contents';

  // Angular 19 Signal-based Inputs
  asTag = input<'div' | 'article' | 'section'>('section');

  /** Variant props */
  variant = input<'Default' | 'Elevated' | 'Outlined'>('Default');
  padding = input<'None' | 'Small' | 'Regular' | 'Large'>('Regular');
  borderRadius = input<'None' | 'Small' | 'Regular' | 'Large'>('Regular');
  gap = input<'None' | 'Small' | 'Regular' | 'Large'>('Regular');

  /** Interactive props */
  clickable = input(false, { transform: booleanAttribute });
  hoverable = input(false, { transform: booleanAttribute });

  /** State props */
  disabled = input(false, { transform: booleanAttribute });
  selected = input(false, { transform: booleanAttribute });

  /** Event outputs */
  cardClick = output<Event>();

  /** Computed */
  role = computed(() => {
    if (this.clickable() && !this.disabled()) return 'button';
    if (this.asTag() === 'article') return 'article';
    if (this.asTag() === 'section') return 'section';
    return null;
  });

  /** Event handlers */
  onCardClick(event: Event): void {
    if (this.disabled() || !this.clickable()) return;
    this.cardClick.emit(event);
  }

  onCardKeydown(event: KeyboardEvent): void {
    if (event.key === 'Enter' || event.key === ' ') {
      this.onCardClick(event);
    }
  }
}
